// Angular
import { Inject, Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

// Local library
import { CommonFacade, ENVIRONMENT } from '@amwager/data-access';
import { MatNotificationService } from '@amwager/util';

// Local file
import { FundingFacade } from '../+state';
import { FundingService } from './funding.service';

/**
 * Business logic for the deposit promo-code component.
 * Note: the logout/hide-notification handling stays in the component because
 * it needs AuthFacade, and authentication/data-access already depends on
 * funding/data-access (importing it here would be a circular dependency).
 */
@Injectable()
export class DepositPromoCodeService {

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly fundingFacade: FundingFacade,
    private readonly matNotificationService: MatNotificationService,
    private readonly commonFacade: CommonFacade,
    private readonly fundingService: FundingService,
    @Inject(ENVIRONMENT) private readonly environment: string,
  ) {}

  /** Build the promo-code form. */
  buildForm(): FormGroup {
    return this.formBuilder.group({
      promoCode: ['', [Validators.required]]
    });
  }

  /** Dispatch the promo-code deposit and stream the result. */
  deposit$(promoCode: string) {
    this.fundingFacade.depositPromoCode(promoCode);
    return this.fundingFacade.isDepositPromoCodeSuccess$();
  }

  /** Dismiss any open notification. */
  hideNotifications(): void {
    this.matNotificationService.hide();
  }

  /** Flag the app as offline for the given source. */
  setOffline(source: string): void {
    this.commonFacade.setIsConnectedInternet(source, false);
  }

  /** Mark all controls touched to reveal validation messages. */
  markFormGroupTouched(formGroup: FormGroup): void {
    this.fundingService.markFormGroupTouched(formGroup);
  }

  /** Show a single-button alert. */
  showAlert(header: string, message: string): void {
    this.matNotificationService.showAlert(header, message, undefined, undefined, 'Close');
  }

  /** Watch connectivity and report changes back to the caller. */
  checkConnectivity(source: string, onChange: (online: boolean) => void): void {
    this.fundingService.checkConnectivity(this.environment, source, onChange);
  }

}
